import type { FormConfig } from '../services/api';

export const DEFAULT_FORM_CONFIG: FormConfig = {
  minimumPersonen: 25,
};

// Minutes between two "HH:MM" times, or null when either is missing or the end is not later.
// An end time up to 04:00 before the start is read as after midnight (same rule as the server).
export const openMinutes = (start: string, end: string): number | null => {
  if (!start || !end) return null;
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  let minutes = eh * 60 + em - (sh * 60 + sm);
  if (minutes <= 0 && eh * 60 + em <= 4 * 60) minutes += 24 * 60;
  return minutes > 0 ? minutes : null;
};

export const formatDuration = (minutes: number) =>
  `${Math.floor(minutes / 60)}u${minutes % 60 ? String(minutes % 60).padStart(2, '0') : ''}`;
